import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=f584cd6e&scoped=true&"
import script from "./Limit.vue?vue&type=script&lang=ts&"
export * from "./Limit.vue?vue&type=script&lang=ts&"
import style0 from "./Limit.vue?vue&type=style&index=0&id=f584cd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f584cd6e",
  null
  
)

export default component.exports